// extracted by mini-css-extract-plugin
module.exports = {"modals":"Notifications_modals___dONC","tooltips":"Notifications_tooltips__OeuNa","toasts":"Notifications_toasts__sX_Ex"};